import React, {
  useEffect,
  useState,
  useContext
} from 'react';
import {
  Box,
  Container,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import Page from 'src/components/Page';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    paddingRight: '40px',
    paddingLeft: '40px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  },
  header: {
    fontSize: '16px',
    fontFamily: 'Roboto',
    fontWeight: 500,
    color: '#3E3E3E'
  },
  celula: {
    fontSize: '16px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    color: '#808080'
  },
  titulo: {
    fontSize: '20px',
    color: '#3E3E3E',
    fontWeight: 700,
    marginBottom: '30px'
  }
}));

const Registros = () => {
  const auth = useContext(AuthContext);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const classes = useStyles();
  const [relatorios, setRelatorios] = useState([]);

  useEffect(() => {
    const fetchSituacoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/relatorios/historico`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        if (responseData.sucesso) {
          setRelatorios(responseData.data);
          clearError();
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchSituacoes();
  }, [sendRequest, auth]);
  return (
    <Page
      className={classes.root}
      title="Registros"
    >
      <Container maxWidth={false}>
        <Box mt={3}>
          <Typography
            color="textPrimary"
            align="left"
            variant="h1"
            className={classes.titulo}
          >
            Registros
          </Typography>
          <PerfectScrollbar>
            <Box minWidth={1050}>
              <Table className={classes.table} size="medium" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.header}>Item</TableCell>
                    <TableCell
                      className={classes.header}
                      align="left"
                    >
                      Alteração
                    </TableCell>
                    <TableCell
                      className={classes.header}
                      align="left"
                    >
                      Usuário
                    </TableCell>
                    <TableCell
                      className={classes.header}
                      align="left"
                    >
                      Data
                    </TableCell>
                    <TableCell
                      className={classes.header}
                      align="left"
                    >
                      Horário
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {relatorios.map((row) => {
                    if (row.meta.alterados) {
                      return row.meta.alterados.map((alteracao) => (
                        <TableRow key={row.id}>
                          <TableCell
                            className={classes.celula}
                            component="th"
                            scope="row"
                          >
                            {row.nome}
                          </TableCell>
                          <TableCell
                            className={classes.celula}
                            align="left"
                          >
                            {alteracao}
                          </TableCell>
                          <TableCell
                            className={classes.celula}
                            align="left"
                          >
                            {row.meta.actionBy.nome}
                          </TableCell>
                          <TableCell
                            className={classes.celula}
                            align="left"
                          >
                            {moment(row.time).format('DD/MM/YYYY')}
                          </TableCell>
                          <TableCell
                            className={classes.celula}
                            align="left"
                          >
                            {moment(row.time).format('HH:MM')}
                          </TableCell>
                        </TableRow>
                      ));
                    }
                    return <></>;
                  })}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          {isLoading && <LoadingSpinner asOverlay />}
          <ErrorMessage error={error} onClear={clearError} />
        </Box>
      </Container>
    </Page>
  );
};

export default Registros;
